import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

// Hooks
import { useCoachingV2RouteHandler } from 'Dashboard/components/CoachingPageV2/use-coaching-v2-route-handler';

// Constants
import QueryParamConstants from 'Shared/constants/QueryParams.constants';
import { Data as PeerReviewCompletedModalData } from './PeerReviewCompletedModalData.constants';
import { Data as SelfPeerReviewCompletedModalData } from './SelfPeerReviewCompletedModalData.constants';
import PageUrls from 'Shared/constants/PageUrls.constants';

// Components
import NewFeatureCarouselModal from 'Dashboard/components/NewFeatureCarouselModal/NewFeatureCarouselModal';

enum flowType {
  self = 'self',
  peer = 'peer',
}
const PeerReviewCompletedModal = () => {
  const [activeVersion, setActiveVersion] = useState<flowType>(null);
  const { search } = useLocation();
  const { handleCoachingV2Redirect } = useCoachingV2RouteHandler();

  const isOpen = activeVersion !== null;

  useEffect(() => {
    if (search.includes(QueryParamConstants.PEER_REVIEW_COMPLETED)) {
      setActiveVersion(flowType.peer);
      handleCoachingV2Redirect({ pathname: PageUrls.COACHING_360 });
    }
    if (search.includes(QueryParamConstants.PEER_SELF_REVIEW_COMPLETED)) {
      setActiveVersion(flowType.self);
      handleCoachingV2Redirect({ pathname: PageUrls.COACHING_360 });
    }
  }, [search]);

  const data = activeVersion === flowType.self ? SelfPeerReviewCompletedModalData : PeerReviewCompletedModalData;

  return <NewFeatureCarouselModal isOpen={isOpen} toggleIsOpen={() => setActiveVersion(null)} data={data} />;
};

export default PeerReviewCompletedModal;
